var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon11({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58.1100006px",
    height: "70.5121289px",
    viewBox: "0 0 58.1100006 70.5121289",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-776.060000, -2419.897871)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2",
    transform: "translate(-0.060000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M784.53,2469.58 L784.53,2475.58 C784.542579,2479.12207 787.407954,2481.99191 790.95,2482.01 L819.39,2482.01 C821.091613,2482.01428 822.725035,2481.34148 823.93,2480.14 L823.93,2480.12 C825.140039,2478.91914 825.820422,2477.28478 825.82,2475.58 L825.82,2465.56 L805.17,2465.56 L805.17,2457.16 L834.23,2457.16 L834.23,2475.58 C834.230793,2479.5127 832.665488,2483.28382 829.88,2486.06 L829.87,2486.05 C827.094149,2488.83719 823.323673,2490.40583 819.39,2490.41 L790.95,2490.41 C782.764641,2490.39788 776.132116,2483.76536 776.12,2475.58 L776.12,2469.58 L784.53,2469.58 L784.53,2469.58 Z M788.54,2452.63 L788.54,2436.51 C788.541922,2432.1066 790.298058,2427.88539 793.42,2424.78 L793.42,2424.76 C798.175821,2420.01159 805.322195,2418.59239 811.531549,2421.16321 C817.740903,2423.73403 821.792583,2429.7895 821.8,2436.51 L821.8,2452.63 L813.4,2452.63 L813.4,2436.51 C813.403788,2433.18389 811.400379,2430.18413 808.326566,2428.91342 C805.252753,2427.64271 801.715965,2428.35214 799.37,2430.71 L799.36,2430.7 C797.816291,2432.23931 796.94908,2434.32997 796.95,2436.51 L796.95,2452.63 L788.54,2452.63 Z",
    id: "Path_115",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_116",
    fill: "#BEB0FF",
    points: "800.97 2465.57 776.12 2465.57 776.12 2457.16 800.97 2457.16"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/Icon11.acce14fc44f54f1697b106364039e869.svg";
export { ForwardRef as ReactComponent };